function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "icon_svg__a",
  x: 14,
  y: 10,
  width: 17,
  height: 17,
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 2,
  result: "b"
}), /*#__PURE__*/React.createElement("feFlood", {
  floodColor: "#fff",
  floodOpacity: 0.706
}), /*#__PURE__*/React.createElement("feComposite", {
  operator: "in",
  in2: "b"
}), /*#__PURE__*/React.createElement("feComposite", {
  "in": "SourceGraphic"
})), /*#__PURE__*/React.createElement("filter", {
  id: "icon_svg__c",
  x: 2,
  y: 18,
  width: 17,
  height: 17,
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 2,
  result: "d"
}), /*#__PURE__*/React.createElement("feFlood", {
  floodColor: "#fff",
  floodOpacity: 0.706
}), /*#__PURE__*/React.createElement("feComposite", {
  operator: "in",
  in2: "d"
}), /*#__PURE__*/React.createElement("feComposite", {
  "in": "SourceGraphic"
})), /*#__PURE__*/React.createElement("filter", {
  id: "icon_svg__e",
  x: 26,
  y: 18,
  width: 17,
  height: 17,
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 2,
  result: "f"
}), /*#__PURE__*/React.createElement("feFlood", {
  floodColor: "#fff",
  floodOpacity: 0.706
}), /*#__PURE__*/React.createElement("feComposite", {
  operator: "in",
  in2: "f"
}), /*#__PURE__*/React.createElement("feComposite", {
  "in": "SourceGraphic"
})), /*#__PURE__*/React.createElement("style", null, ".icon_svg__b{fill:#ffb7c3}.icon_svg__c{fill:#fff}"));

var _ref2 = /*#__PURE__*/React.createElement("path", {
  className: "icon_svg__b",
  d: "M22.5 37.002a1.5 1.5 0 01-1.5-1.5v-11.5h3v11.5a1.5 1.5 0 01-1.5 1.5zm1.5-24h-3v-3.5a1.5 1.5 0 113 0v3.5zM34.5 37.002a1.5 1.5 0 01-1.5-1.5v-3.5h3v3.5a1.5 1.5 0 01-1.5 1.5zm1.5-16h-3v-11.5a1.5 1.5 0 113 0v11.5zM10.5 37.002a1.5 1.5 0 01-1.5-1.5v-3.5h3v3.5a1.5 1.5 0 01-1.5 1.5zm1.5-16H9v-11.5a1.5 1.5 0 113 0v11.5z"
});

var _ref3 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(-3 -.787)"
}, /*#__PURE__*/React.createElement("rect", {
  className: "icon_svg__b",
  width: 3,
  height: 9,
  rx: 1.5,
  transform: "translate(4 .787)"
}), /*#__PURE__*/React.createElement("rect", {
  className: "icon_svg__b",
  width: 3,
  height: 9,
  rx: 1.5,
  transform: "rotate(-90 3.893 -.107)"
}), /*#__PURE__*/React.createElement("g", {
  transform: "rotate(-90 26 23.287)"
}, /*#__PURE__*/React.createElement("rect", {
  className: "icon_svg__b",
  width: 3,
  height: 9,
  rx: 1.5,
  transform: "translate(4 .787)"
}), /*#__PURE__*/React.createElement("rect", {
  className: "icon_svg__b",
  width: 3,
  height: 9,
  rx: 1.5,
  transform: "rotate(-90 3.893 -.107)"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(38 36.787)"
}, /*#__PURE__*/React.createElement("rect", {
  className: "icon_svg__b",
  width: 3,
  height: 9,
  rx: 1.5,
  transform: "translate(6)"
}), /*#__PURE__*/React.createElement("rect", {
  className: "icon_svg__b",
  width: 3,
  height: 9,
  rx: 1.5,
  transform: "rotate(90 1.5 7.5)"
})), /*#__PURE__*/React.createElement("g", {
  transform: "rotate(-90 24.393 -14.107)"
}, /*#__PURE__*/React.createElement("rect", {
  className: "icon_svg__b",
  width: 3,
  height: 9,
  rx: 1.5,
  transform: "translate(6)"
}), /*#__PURE__*/React.createElement("rect", {
  className: "icon_svg__b",
  width: 3,
  height: 9,
  rx: 1.5,
  transform: "rotate(90 1.5 7.5)"
})));

var _ref4 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(0 -.002)",
  filter: "url(#icon_svg__a)"
}, /*#__PURE__*/React.createElement("rect", {
  className: "icon_svg__c",
  width: 5,
  height: 5,
  rx: 1,
  transform: "translate(20 16)"
}));

var _ref5 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(0 -.002)",
  filter: "url(#icon_svg__c)"
}, /*#__PURE__*/React.createElement("rect", {
  className: "icon_svg__c",
  width: 5,
  height: 5,
  rx: 1,
  transform: "translate(8 24)"
}));

var _ref6 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(0 -.002)",
  filter: "url(#icon_svg__e)"
}, /*#__PURE__*/React.createElement("rect", {
  className: "icon_svg__c",
  width: 5,
  height: 5,
  rx: 1,
  transform: "translate(32 24)"
}));

var SvgIcon = function SvgIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45
  }, props), _ref, _ref2, _ref3, _ref4, _ref5, _ref6);
};

export default "data:image/svg+xml;base64,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";
export { SvgIcon as ReactComponent };